import ResyRewardsAppStoreButton from './ResyRewardsAppStoreButton';

export default ResyRewardsAppStoreButton;
